import React from 'react';
import { Chip, Tooltip, Typography } from '@mui/material';

export type ResultOutcome = 'PASS' | 'FAIL' | 'PENDING';

const LOOK: Record<ResultOutcome, { label: string; color: 'success' | 'error' | 'default' }> = {
  PASS: { label: 'Pass', color: 'success' },
  FAIL: { label: 'Fail', color: 'error' },
  PENDING: { label: 'In progress', color: 'default' },
};

/**
 * An exam's pass/fail result, as the server decided it under the school's
 * result rules (Settings → Results). A failed result names the failed
 * papers on hover. Renders a dash when there is no result to show.
 */
const OutcomeChip: React.FC<{ outcome: ResultOutcome | null | undefined; failedSubjects?: string[] }> = ({ outcome, failedSubjects = [] }) => {
  if (!outcome) return <Typography variant="body2" color="text.disabled">—</Typography>;
  const look = LOOK[outcome];
  const chip = (
    <Chip size="small" label={look.label} color={look.color} variant={outcome === 'PENDING' ? 'outlined' : 'filled'}
      sx={{ fontWeight: 700, minWidth: 56 }} />
  );
  return outcome === 'FAIL' && failedSubjects.length
    ? <Tooltip title={`Failed ${failedSubjects.join(', ')}`}>{chip}</Tooltip>
    : chip;
};

export default OutcomeChip;
